import React from 'react';
import { Badge } from 'react-bootstrap';
import { CalcExplain, FieldDescriptor } from 'blaze-form';

const CalculationSummary = ({ manager }) => {
  const fields = manager.layout.getAllInputFields();
  const formLookup = manager.layout.getLookup();

  return (
    <div className="calc-summary">
      {fields.map(fieldName => {
        if (!formLookup[fieldName].calculate) {
          return null;
        }
        return (
          <div className="calc-popover" key={fieldName} style={{ borderBottom: '1px solid #ccc', paddingBottom: '5px', marginBottom: '10px' }}>
            <div className="calc-explain">
              <FieldDescriptor fieldName={fieldName} lookup={formLookup} />
            </div>

            <div className="d-flex flex-direction-row align-items-center" style={{ paddingLeft: '25px' }}>
              <Badge variant="success" className="mr-2">
                <i className="fas fa-equals" />
              </Badge>
              <CalcExplain fieldName={fieldName} formManager={manager} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CalculationSummary;
